import React from 'react';
import { languageCodeToFriendly } from '../helpers';

type LanguageCodeProps = {
  languageCode: string;
};
const LanguageCode: React.FC<LanguageCodeProps> = (props) => {
  return <>{languageCodeToFriendly(props.languageCode)}</>;
};

export default LanguageCode;
